








import { Component, Vue } from "vue-property-decorator";

import axios from "@/api/axios";
import Snackbar from "@/components/shared/Snackbar.vue";
import SuccessDialog from "@/components/shared/SuccessDialog.vue";
import { snackBarEventBus, snackBarEventName } from "@/eventBuses/snackBar.eventBus";
import { ActivityTracker } from "@/utils/activityTracker";
import { sleep } from "@/utils/sleep";

@Component({
  components: {
    Snackbar,
    SuccessDialog,
  },
})
export default class App extends Vue {
  snackbar = false;
  snackbarText = "";
  snackbarType = "";
  logoutDialog = false;

  onLogoutDialogClose() {
    this.logoutDialog = false;
    this.$router.push({ path: `/auth/signin` });
  }

  async created() {
    document.title = process.env.VUE_APP_BRAND_DOMAIN || "/";
    snackBarEventBus.$on(snackBarEventName, async (message: { message: string; type: string }) => {
      this.snackbar = false;
      await sleep(1);
      this.snackbarText = message.message;
      this.snackbarType = message.type;
      this.snackbar = true;
    });
    axios.interceptors.response.use(undefined, async (err) => {
      if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
        await this.$store.dispatch("refreshToken");
        // eslint-disable-next-line require-atomic-updates
        err.config.__isRetryRequest = true;
        err.config.headers.Authorization = "Bearer " + this.$store.getters.token;
        return axios(err.config);
      } else {
        throw err;
      }
    });
    axios.interceptors.request.use(
      (config) => {
        config.headers.Authorization = "Bearer " + this.$store.getters.token;
        return config;
      },
      (error) => Promise.reject(error),
    );
    window.addEventListener("storage", async (data) => {
      if (data.key === "tc" && this.$store.getters.isLoggedIn && data.newValue && ActivityTracker.isStarted) {
        if (data.newValue === "logout") {
          await this.$store.dispatch("logOut");
          this.logoutDialog = true;
        } else if (/reset/.test(data.newValue)) {
          ActivityTracker.resetTimer();
        }
      }
    });
  }
  updated() {
    if (this.$store.getters.isLoggedIn && !ActivityTracker.isStarted) {
      ActivityTracker.startTimer(async () => {
        await this.$store.dispatch("logOut");
        this.logoutDialog = true;
        localStorage.setItem("tc", "logout");
      });
      ActivityTracker.addListener("mousemove");
    } else if (!this.$store.getters.isLoggedIn) {
      ActivityTracker.removeListener("mousemove");
    }
  }
}
